import {
  Component,
  inject,
  OnDestroy,
  OnInit,
  Signal,
  viewChild,
} from '@angular/core';
import { NgProgressService } from '@shared/services/ng-progress.service';
import { NgProgressbar, NgProgressRef } from 'ngx-progressbar';
import { NgProgressHttp } from 'ngx-progressbar/http';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-ng-progress',
  imports: [NgProgressbar, NgProgressHttp],
  templateUrl: './ng-progress.component.html',
  styleUrl: './ng-progress.component.css',
})
export class NgProgressComponent implements OnInit, OnDestroy {
  progressBar: Signal<NgProgressRef | undefined> = viewChild(NgProgressRef);

  private loadingSub: Subscription = Subscription.EMPTY;

  private readonly _ngProgressService = inject(NgProgressService);

  ngOnInit(): void {
    this.loadingSub = this._ngProgressService.loading$.subscribe((state) => {
      state ? this.start() : this.complete();
    });
  }

  start(): void {
    this.progressBar()?.start();
  }

  complete(): void {
    this.progressBar()?.complete();
  }

  ngOnDestroy(): void {
    this.loadingSub.unsubscribe();
  }
}
